import { API_BASE_URL } from "@constants/urls";
import { getAuthProvider } from "@helpers/auth-provider";
import axios from "axios";
import { randomUUID } from "expo-crypto";
import { commerceBasePath } from "./constants";
import type { ExternalAuthResponse } from "./types";

export const handleExternalAuth = async ({
	token,
	platform,
	tenantId,
}: {
	token: string;
	platform?: string;
	tenantId?: string;
}): Promise<ExternalAuthResponse> => {
	// TODO(backend): verify inbound JWT signature against tenant Clerk JWKS;
	// validate issuer/audience/expiry; cache jti/sid server-side for replay protection.
	const { data } = await axios.post(
		`${API_BASE_URL}/${commerceBasePath}/auth/external`,
		{
			token,
			platform,
			provider: getAuthProvider(),
			tenantId,
			nonce: randomUUID(),
		},
	);

	return data;
};
